/* eslint max-len:0 */
import React, { memo } from 'react';
export var BzLogo = /*#__PURE__*/memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#fff' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100%' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width;
  return /*#__PURE__*/React.createElement("svg", {
    fill: color,
    height: height,
    viewBox: "0 0 256.72 38.54",
    width: width
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M352.26,258.41h11.48c5.74,0,10.08,2.5,10.08,7.76,0,3.54-2.32,5.8-5.68,6.84v.06a7.66,7.66,0,0,1,7.15,7.76c0,5.56-5.19,8.67-11.67,8.67H352.26Zm4.46,12.89h6.11c3.42,0,6.17-1.28,6.17-4.64,0-2.44-1.65-4.58-5.25-4.58h-7.08v9.22Zm0,14.54h6.6c2.69,0,7.15-.86,7.15-5.25,0-3.66-2.75-5.56-7.08-5.56h-6.66Z",
    transform: "translate(-351 -253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.29,258.41v19.06c0,3.85,2.08,8.86,8.31,8.86s8.31-5,8.31-8.86V258.41h4.52v19.73c0,7.21-5.56,12.15-12.83,12.15s-12.83-4.95-12.83-12.15V258.41Z",
    transform: "translate(-351 -253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.8,276.24l-12.52-17.83H411l9,13.68,9.28-13.68h5.5l-12.52,17.83v13.25H417.8Z",
    transform: "translate(-351 -253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.24,258.41h21.38v4H440.76v9.28h15.7v4h-15.7v10h17.71v4H436.24Z",
    transform: "translate(-351 -253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.5,258.41h11.67c8.49,0,10.63,4.76,10.63,8.73s-3.11,7.7-8.12,8.25l9.41,14.23H480.4L472,275.87h-5v13.74h-4.52V258.41ZM467,272.09h5.86c3.54,0,7.08-.79,7.08-5s-3.54-5-7.08-5H467Z",
    transform: "translate(-351 -253)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M487.42,285.58l17.71-23.21H488v-4h22.48v4L492.8,285.58h17.89v4H487.42Z",
    transform: "translate(-351 -253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.25,258.41h5.56L571,284H571V258.41h4.21v31.15h-5.37L552.53,264h-.06v25.59h-4.21Z",
    transform: "translate(-351 -253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581,258.41h20.09v4H585.26v9.28H600v4H585.26v10h16.67v4H581Z",
    transform: "translate(-351 -253)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M517,282.23l2.57.12a13.45,13.45,0,0,1-2.75-7.63c-.43-7.15,4.28-13.19,11.54-13.62a11.88,11.88,0,0,1,8.25,2.5l2.87.12.24-2.44a16.32,16.32,0,0,0-11.48-3.6c-9.47.55-15.82,7.88-15.27,17.28A16.89,16.89,0,0,0,516.92,285Z",
    transform: "translate(-351 -253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.17,262.74l-.24,2.69-2.63-.12a13.68,13.68,0,0,1,3.05,8c.43,7.15-4.28,13.19-11.54,13.62a12.06,12.06,0,0,1-8.67-2.87l-2.63-.12-.24,2.57A16.13,16.13,0,0,0,530,290.29c9.47-.55,15.82-7.88,15.27-17.28A16.2,16.2,0,0,0,541.17,262.74Z",
    fill: "#3e91ec",
    transform: "translate(-351 -253)"
  }))));
});